// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3de095ef","453":"f92ce9be","732":"edc082dd","977":"14d6447b"}[chunkId] + ".chunk.js";
};